import apiSlice from "./apiSlice";

const engineeringDashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getEngineeringProgressKpi: builder.query({
            query: ({ projectId }) => ({
                url: `EngineeringDocuments/progress-kpi`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["EngineeringProgressKpi"],
        }),

        getEngineeringPlanVsActual: builder.query({
            query: ({ projectId }) => ({
                url: `EngineeringDocuments/plan-vs-actual`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["EngineeringPlanVsActual"],
        }),

        getEngineeringProgressCurve: builder.query({
            query: ({ projectId }) => ({
                url: `EngineeringDocuments/s-curve`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["EngineeringProgressCurve"],
        }),

        getEngineeringApprovalBottleneck: builder.query({
            query: ({ projectId }) => ({
                url: `EngineeringDocuments/approval-bottleneck`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["EngineeringApprovalBottleneck"],
        }),

        getEngineeringStatusBreakdown: builder.query({
            query: ({ projectId }) => ({
                url: `EngineeringDocuments/status-breakdown`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["EngineeringStatusBreakdown"],
        }),

        getEngineeringStatusByDepartment: builder.query({
            query: ({ projectId }) => ({
                url: `EngineeringDocuments/status-by-department`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["EngineeringStatusByDepartment"],
        }),

        getEngineeringPendingBreakdown: builder.query({
            query: ({ projectId }) => ({
                url: `EngineeringDocuments/pending-breakdown`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["EngineeringPendingBreakdown"],
        }),
    }),
});

export const {
    useGetEngineeringProgressKpiQuery,
    useGetEngineeringPlanVsActualQuery,
    useGetEngineeringProgressCurveQuery,
    useGetEngineeringApprovalBottleneckQuery,
    useGetEngineeringStatusBreakdownQuery,
    useGetEngineeringStatusByDepartmentQuery,
    useGetEngineeringPendingBreakdownQuery,
} = engineeringDashboardApiSlice;
